module.exports = __webpack_public_path__ + "img/3.01c0d2e4.jpg";